'use strict';

import Auth from './Auth';

class Organizations {
  static getOrganizations(filters = null) {
    let query = '';

    if (filters != null) {
      for (let filter in filters) {
        if (Array.isArray(filters[filter])) {
          if (filters[filter].length > 0) {
            query += `${filter}=${filters[filter].join(',')}&`;
          }
        } else {
          query += `${filter}=${filters[filter]}&`;
        }
      }
    }

    //Remuevo último caracter si es &
    if (query.slice(-1) == '&') {
      query = query.slice(0, -1);
    }

    return Auth.makePrivateGet(`${BASE_URL}api/organizations?${query}`);
  }

  static getOrganizationContacts(filters) {
    let query = '';

    if (filters != null) {
      for (let filter in filters) {
        if (Array.isArray(filters[filter])) {
          if (filters[filter].length > 0) {
            query += `${filter}=${filters[filter].join(',')}&`;
          }
        } else {
          query += `${filter}=${filters[filter]}&`;
        }
      }
    }

    //Remuevo último caracter si es &
    if (query.slice(-1) == '&') {
      query = query.slice(0, -1);
    }

    return Auth.makePrivateGet(
      `${BASE_URL}api/organizations/contacts?${query}`
    );
  }

  static getOrganizationById(id) {
    return Auth.makePrivateGet(`${BASE_URL}api/organizations/${id}`);
  }

  static createOrganizationBrand(id, params = null)
  {
      return Auth.makePrivatePost(`${BASE_URL}api/organizations/${id}/brands`, params);
  }

  static createOrganization( params = null)
  {
      return Auth.makePrivatePost(`${BASE_URL}api/organizations`, params);
  }

  static updateOrganizationBrand(){
    return true;
  }

}

export default Organizations;
